import { BlockTypes } from '@/models/commercial-proposals/blocks.store';
import {
  Button,
  Flex,
  Group,
  Modal,
  Paper,
  SimpleGrid,
  Text,
  ThemeIcon,
  useMantineTheme,
} from '@mantine/core';
import { PiPackage, PiTable, PiTextT } from 'react-icons/pi';

interface ContentBlockOption {
  type: BlockTypes;
  label: string;
  icon: React.ReactNode;
}

const CONTENT_BLOCK_OPTIONS: ContentBlockOption[] = [
  {
    type: BlockTypes.Text,
    label: 'Text Block',
    icon: <PiTextT size={24} />,
  },
  {
    type: BlockTypes.Services,
    label: 'Services Table',
    icon: <PiTable size={24} />,
  },
  {
    type: BlockTypes.ServicesInOnePackage,
    label: '1-Tier Package',
    icon: <PiPackage size={24} />,
  },
  {
    type: BlockTypes.ServicesInTwoPackages,
    label: '2-Tier Packages',
    icon: <PiTable size={24} />,
  },
  {
    type: BlockTypes.ServicesInThreePackages,
    label: '3-Tier Packages',
    icon: <PiTable size={24} />,
  },
];

interface ContentBlockSelectorProps {
  opened: boolean;
  onClose: () => void;
  onSelect: (type: BlockTypes) => void;
}

export default function ContentBlockSelector({
  opened,
  onClose,
  onSelect,
}: ContentBlockSelectorProps) {
  const theme = useMantineTheme();

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="Add Content Block"
      size="lg"
      centered
      padding="md"
      className="no-block-deselect"
    >
      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md" mt="md">
        {CONTENT_BLOCK_OPTIONS.map((option) => (
          <Paper
            key={option.type}
            shadow="xs"
            p="md"
            withBorder
            radius="sm"
            onClick={() => {
              onSelect(option.type);
              onClose();
            }}
            style={{
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              borderColor: theme.colors.gray[3],
            }}
          >
            <Flex align="center" gap="md">
              <ThemeIcon size={42} radius="sm" variant="light" color="gray">
                {option.icon}
              </ThemeIcon>

              <Text fw={500}>{option.label}</Text>
            </Flex>
          </Paper>
        ))}
      </SimpleGrid>

      <Group justify="flex-end" mt="xl">
        <Button variant="default" onClick={onClose}>
          Cancel
        </Button>
      </Group>
    </Modal>
  );
}
